import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { redirigirSegunUser } from "utils/generalFunctions";

const ClienteProtectedRoutes = ({ children }) => {
  const { user, status } = useSelector((state) => state.auth);

  if (user == null) {
    return <Navigate to={"/"} />;
  } else {
    return children;
  }
};

export default ClienteProtectedRoutes;
